<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon
          left
          class="icon-style"
        >
          mdi-shape-plus-outline
        </v-icon>Create Category
      </h2>
      <v-form ref="form">
        <v-container>
          <v-card-text class="text-body-1 text-center">
            <v-row
              class="fill-height"
            >
              <v-col
                cols="12"
                md="12"
              >
                <v-text-field
                  v-model="category"
                  placeholder="Category Name"
                  :rules="[(v) => !!v || 'This field is required']"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-chip
              v-for="item in categoriesList"
              :key="item.id"
              outlined
              class="ml-2"
            >
              <span @click="deleteCategory(item)">{{ item.name }} <v-icon>mdi-close</v-icon></span>
            </v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              @click="createCategory()"
            >
              create
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-form>
      <centre-spinner
        :loading="loading"
      />
      <delete-dialog
        v-if="showDelete"
        :title="'Delete Blog?'"
        @closed="showDelete = false"
        @confirmed="deleteConfirmed()"
      />
    </v-card>
  </v-dialog>
</template>
    <script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import DeleteDialog from 'src/views/dashboard/component/DeleteDialog';

  export default {
    components: {
      'centre-spinner': spinner,
      'delete-dialog': DeleteDialog,
    },
    data () {
      return {
        showModal: true,
        loading: false,
        itemForDelete: null,
        showDelete: false,
        category: null,
      };
    },
    computed: {
      categoriesList () {
        return this.$store.getters['blogs/getCategories'];
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
    },
    methods: {
      async createCategory () {
        if (this.$refs.form.validate() === true) {
          this.loading = true;
          await this.$store.dispatch('blogs/createCategory', {
            name: this.category,
            type: 'blog',
          }).then(response => {
            this.$store.dispatch('alert/onAlert', {
              message: 'Category added successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            this.fetchCategory();
            this.$emit('closed');
            this.loading = false;
          }).catch(() => {
            this.loading = false;
          });
        } else {
          this.$store.dispatch('alert/onAlert', {
            message: 'Fill all fields',
            type: Constants.ALERT_TYPE_ERROR,
          });
        }
      },
      deleteCategory (item) {
        this.itemForDelete = item;
        this.showDelete = true;
      },
      async deleteConfirmed () {
        await this.$store.dispatch('blogs/deleteCategory', {
          id: this.itemForDelete.id,
        }).then(() => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Category deleted successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
        });
        await this.fetchCategory();
        this.$emit('closed');
      },
      async fetchCategory () {
        await this.$store.dispatch('blogs/fetchCategories', {
          resourceType: 'blog',
        });
      },
    },
  };
    </script>
    <style scoped>
    .title-style {
      color: #37474F;
      margin-left: 30px;
    }
    .icon-style {
      color: #37474F;
      font-size: 45px;
    }
    </style>
